import { StatusDot } from "@/components/settings/StatusBadge";

interface SummaryRowProps {
  /** Definition term shown in the left column */
  label: string;
  /** Definition value shown in the right column */
  value: string;
  /** Optional state dot rendered before the value */
  dot?: "active" | "muted";
}

/**
 * Single row in the sync card's definition-list summary. Renders an optional
 * status dot before the value so booleans read at a glance.
 * @param props - SummaryRowProps
 * @returns Definition term + description pair
 */
export function SummaryRow({ label, value, dot }: SummaryRowProps) {
  return (
    <>
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="flex items-center gap-2 font-medium">
        {dot && <StatusDot tone={dot} />}
        <span>{value}</span>
      </dd>
    </>
  );
}

/**
 * Summary row for a field mapping section, showing the count of mapped fields.
 * @param props - label and count of mapped fields
 * @returns SummaryRow with "X fields mapped" or "Not set"
 */
export function MappingCountRow({
  label,
  count,
}: {
  label: string;
  count: number;
}) {
  return (
    <SummaryRow
      label={label}
      value={count > 0 ? `${count} fields mapped` : "Not set"}
      dot={count > 0 ? "active" : "muted"}
    />
  );
}
